<template>
  <div>
    <v-dialog
      v-model="success"
      width="350"
      scroll-strategy="none"
      target="parent"
      transition="none"
    >
      <div class="dialog-custom">
        <p>Formulář byl úspěšně odeslán.</p>
        <div class="d-flex justify-center">
          <v-btn
            variant="flat"
            color="#283583"
            class="mt-5"
            @click="success = false"
          >
            Pokračovat
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <v-form @submit.prevent="submitForm">
      <h2>Napište nám</h2>
      <v-text-field
        v-model="personalName"
        label="Vaše jméno"
        variant="solo"
        bg-color="#e2e9ff"
        :error-messages="getViolation('personalName')"
      />

      <v-text-field
        v-model="email"
        label="Váš e-mail"
        variant="solo"
        bg-color="#e2e9ff"
        :error-messages="getViolation('email')"
      />

      <v-textarea
        v-model="body"
        label="Vaše zpráva"
        variant="solo"
        bg-color="#e2e9ff"
        :error-messages="getViolation('body')"
      />

      <!-- Honeypot: off-screen, real visitors never fill it, bots that fill every input do. -->
      <div
        style="position: absolute; left: -9999px; top: -9999px;"
        aria-hidden="true"
      >
        <label>Website <input
          v-model="website"
          type="text"
          name="website"
          tabindex="-1"
          autocomplete="off"
        ></label>
      </div>

      <div class="d-flex justify-center">
        <v-btn
          variant="flat"
          color="#fff"
          type="submit"
          :loading="loading"
          :disabled="loading"
        >
          odeslat
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VContactForm',
  mixins: [
    errorMixin
  ],
  data () {
    return {
      loading: false,
      personalName: '',
      email: '',
      body: '',
      website: '',
      success: false
    }
  },
  methods: {
    async submitForm () {
      // A second click or Enter while the request runs would send a duplicate inquiry.
      if (this.loading) return
      this.clearViolations()
      try {
        this.loading = true
        await Axios.post('/kontaktni-formular.json', Qs.stringify({
          personalName: this.personalName,
          email: this.email,
          body: this.body,
          website: this.website
        }))

        this.success = true
        this.personalName = ''
        this.email = ''
        this.body = ''
      } catch (error) {
        console.error(error)
        this.buildViolations(error.response)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
